<template>

  <v-container bg fill-height grid-list-md text-xs-center>
    <v-layout row wrap align-center >

      <v-flex  id="scrollWrapper" >
        <v-btn color="blue" dark @click="closeDoc">Go Back</v-btn>

        <h2 style="color:darkred" >Sorry, you don't have permission to view this document.</h2>
        <h3>If you need support please reach out to us:</h3>
        <h3>Email/Web: <a href="https://mnmsba.org/contact-us/" target="_blank">contact us here</a> </h3>
        <h3>Phone: 507-934-2450</h3>
        <h3>Toll-free: 800-324-4459</h3>


      </v-flex>
    </v-layout>
  </v-container>


</template>
<script>

export default {
  name: 'PermissionDenied',
  data () {
    return {
    }
  },
  mounted() {


    this.calculateHeight()

    setInterval(this.calculateHeight,250);
  },
  computed: {
    loggedIn() {
      return !(this.$userData == undefined || this.$userData.email == undefined)
    }

  },
  methods: {
    calculateHeight(forceHeight) {
      let newHeight = null
      if (this.openedDoc == null && document.getElementById("scrollWrapper") != undefined)
        newHeight = document.getElementById("scrollWrapper").scrollHeight
      else if (document.getElementById("documentDialogContent") != undefined)
        newHeight = document.getElementById("documentDialogContent").scrollHeight + 75
      //newHeight = document.getElementsByClassName("documentDialog")[0].scrollHeight


      if(newHeight != this.pageHeight) {
        console.log('height changed', newHeight)
        let message = JSON.stringify({
          event: 'height',
          data: newHeight,
        });
        window.parent.postMessage(message, '*');
        this.pageHeight = newHeight
      }
    },
    closeDoc() {
      this.$router.push({name: 'Search'})
    },
    login() {

      //window.open("https://mnmsba.org/login",'_blank');
    }
  },
  components: {
  },
}
</script>

